import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { QuickActions, QuickActionsDivider, QuickActionsItem } from 'src/shared';
import { confirm, notification } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { useActiveInboxState, useArchiveInbox } from 'src/models/callOffs/hooks';
import { Paths } from 'src/pages/paths';
import { useNavigate } from 'react-router';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { useOpenSidebar } from 'src/shared/InfoSidebar/hooks';
import { faPen, faTrashCan } from '@fortawesome/pro-light-svg-icons';

export interface IProps {}

export const CallOffsQuickActions: FC<IProps> = () => {
  const { t } = useTranslation();
  const [archiveInbox] = useArchiveInbox();
  const openInboxPreview = useOpenSidebar();
  const navigate = useNavigate();

  const [currentInbox] = useActiveInboxState();

  const showDrawer = useCallback(() => {
    currentInbox && openInboxPreview({ id: currentInbox.emailAddress, mode: SidebarMode.INBOX_INFO });
  }, [openInboxPreview, currentInbox]);

  const onArchiveInbox = useCallback(() => {
    confirm.confirm({
      title: t('CallOffs.archiveInbox'),
      content: t('CallOffs.archiveInboxExplanation'),
      okText: t('Common.delete'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      onOk() {
        currentInbox &&
          archiveInbox({
            variables: {
              id: currentInbox.emailAddress
            }
          })
            .then(() => {
              navigate({
                pathname: Paths.CALL_OFFS
              });
            })
            .catch(() =>
              notification.error({
                description: t('Common.unknownErrorDesc'),
                message: t('Common.unknownError')
              })
            );
      },
      onCancel() {
        console.log('Cancel');
      }
    });
  }, [t, currentInbox, archiveInbox, navigate]);

  return (
    <QuickActions>
      <QuickActionsItem onClick={showDrawer} title={t('CallOffs.editInbox')} key={'edit'} icon={faPen} />
      {!!currentInbox?.accessToEdit && (
        <>
          <QuickActionsDivider />
          <QuickActionsItem
            onClick={onArchiveInbox}
            title={t('CallOffs.archiveInbox')}
            key={'archive'}
            icon={faTrashCan}
            danger
          />
        </>
      )}
    </QuickActions>
  );
};

export default CallOffsQuickActions;
